var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "btn-group btn-group-sm mb-2",
          attrs: { "data-toggle": "buttons" }
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-success",
              attrs: { type: "button" },
              on: { click: _vm.openAddModal }
            },
            [_vm._v(_vm._s(_vm.$t("btnAdd")))]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn-group btn-group-sm mb-2",
          attrs: { "data-toggle": "buttons" }
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-info",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("switch", "inventory")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("inventory.switch.inventories")))]
          )
        ]
      ),
      _vm._v(" "),
      _c("VueGoodTable", {
        attrs: {
          columns: _vm.columnsConfig,
          rows: _vm.store.stockTakings,
          paginationOptions: _vm.paginationOptions,
          searchOptions: _vm.searchOptions
        },
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.field === "actions"
                  ? _c("div", { staticClass: "btn-group" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-primary",
                          on: {
                            click: function($event) {
                              return _vm.openEditModal(props.row)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-pen" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-danger",
                          on: {
                            click: function($event) {
                              return _vm.openDeleteModal(props.row)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-trash" })]
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n      "
                      )
                    ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("StockTakingEditModal", { ref: "editModal" }),
      _vm._v(" "),
      _c("StockTakingDeleteModal", { ref: "deleteModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }